import { render } from "./PreferencesPane.vue?vue&type=template&id=466f979d"
import script from "./PreferencesPane.vue?vue&type=script&lang=js"
export * from "./PreferencesPane.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__